import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Timeline from "../Timeline/Membertimelne";
import AlbumsCard from "../../Gallary/Albums/AlbumsCards";
import PhotosCard from "../../Gallary/photos/Photo";
import VideosCard from "../../Gallary/Videos/video";
import ProfileBanner from "./ProfileBanner";
import LeftSidebar from "./LeftSidebar";
import BranchManagement from "./BranchManagement";
import { ProfileGet } from "../../apis/api/ProfileApi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Lodderr from "../../components/Lodder/Lodder";
import { albumGet } from "../../apis/api/GalleryApis";
import "./Profile.css";

const TABS = [
  { key:"about",    label:"About",    icon:"bx bx-user" },
  { key:"branches", label:"Branches", icon:"bx bx-buildings" },
  { key:"Albums",   label:"Albums",   icon:"bx bx-images", gallery:true },
  { key:"Photos",   label:"Photos",   icon:"bx bx-photo-album", gallery:true },
  { key:"videos",   label:"Videos",   icon:"bx bx-video", gallery:true },
];

const Profile = () => {
  const dispatch   = useDispatch();
  const [memberData, setMemberData] = useState([]);
  const [activeTab, setActiveTab]   = useState("about");

  const userId     = Cookies.get("userID");
  const company_id = Cookies.get("company_id");
  const access     = JSON.parse(Cookies.get("access") || "{}");

  const profileData = useSelector(s => s.ProfileSlice.profileData);
  const loading     = useSelector(s => s.ProfileSlice.loading);

  useEffect(() => {
    dispatch(ProfileGet({ userId, company_id }));
    dispatch(albumGet({ company_id }));
  }, []);

  useEffect(() => {
    if (profileData?.data) setMemberData(profileData.data);
  }, [profileData]);

  const visibleTabs = TABS.filter(t => !t.gallery || (access.gallery_access === "1"));

  return (
    <>
      {loading && <Lodderr />}
      <div>
        {memberData && <ProfileBanner profiledata={memberData} />}

        {/* Tabs */}
        <div className="pf-tabs">
          {visibleTabs.map(t => (
            <motion.button key={t.key}
              className={`pf-tab ${activeTab===t.key?"active":""}`}
              onClick={() => setActiveTab(t.key)}
              whileHover={{ scale:1.02 }} whileTap={{ scale:.97 }}>
              <i className={t.icon}></i>{t.label}
            </motion.button>
          ))}
        </div>

        {/* Tab content */}
        <AnimatePresence mode="wait">
          <motion.div key={activeTab}
            initial={{ opacity:0, y:10 }} animate={{ opacity:1, y:0 }}
            exit={{ opacity:0, y:-8 }} transition={{ duration:.28 }}>

            {activeTab === "about" && (
              <div className="pf-layout">
                <LeftSidebar profileData={profileData} />
                <div><Timeline /></div>
              </div>
            )}
            {activeTab === "branches" && <BranchManagement />}
            {activeTab === "Albums" && <AlbumsCard />}
            {activeTab === "Photos" && <PhotosCard />}
            {activeTab === "videos" && <VideosCard />}
          </motion.div>
        </AnimatePresence>
      </div>
    </>
  );
};

export default Profile;
